import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import Home from './pages/Home';
import Experience from './pages/Experience';
import Terms from './pages/Terms';
import Collaborate from './pages/Collaborate';
import NavMenu, { ExpandButton } from './components/NavMenu';

const lightTheme = {
  primaryColor: "#23242c"
};

const theme = lightTheme;

const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    width: 100%;
  }

  body {
    font-size: 17px;
		color: ${theme.primaryColor};
    line-height: 1.6;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    font-family: "Open Sans", sans-serif;
    font-optical-sizing: auto;
  }

  h1 {
    line-height: 1.1;
    font-family: "Playfair Display", serif;
    font-size: 42px;
    margin: 0px;
  }

  h2 {
    font-family: "Playfair Display", serif;
    font-size: 24px;
    font-weight: 700;
  }

  h3 {
    font-family: "Playfair Display", serif;
    font-size: 20px;
    font-weight: 600;
  }


  ul,ol,dl,p,a {
    color: #222;
  }

  ul {
    margin: 1rem 0 1.25rem 1.25rem;
    padding: 0;
  }

  li {
    font-size: 16.5px;
    line-height: 1.5;
    margin-bottom: 0.5rem;
  }
`

const OuterContainer = styled.div`
  display: flex;
  flex: auto;
  width: 100%;
  height: 100%;
`;

const StyledNavMenu = styled(NavMenu)`
  margin-right: 50px;
  flex-basis: 200px;
  flex-grow: 0;
  flex-shrink: 0;
`;

const Social = styled.div`
  margin-top: 20px;

  > * {
    margin: 10px;
    font-size: 30px;
    color: rgba(0,0,0,0.75);
  }

  >:hover {
    color: rgba(0,0,0,1);
  }
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
`;

const Logo = styled.h1`
  text-align: center;
  font-weight: 500;
  font-style: italic;
`;

function App(props) {
  return (
    <div>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <OuterContainer>
          <ExpandButton />
          <StyledNavMenu
            collapsed={props.sidebarCollapsed}
            hidden={props.sidebarHidden}
            header={
              <Logo>RS</Logo>
            }
            footer={
            <Social>
              <a href="https://github.com/RobinSiep"><i className="fab fa-github"></i></a>
              <a href="https://www.linkedin.com/in/robin-siep"><i className="fab fa-linkedin"></i></a>
            </Social>
          }>
            <li><Link to="/">About me</Link></li>
            <li><Link to="/experience">Experience</Link></li>
            <li><Link to="/collaborate">Working together</Link></li>
          </StyledNavMenu>
          <Content>
            <Switch>
              <Route exact
                path="/"
                component={Home} />
              <Route exact
                path="/experience"
                component={Experience} />
              <Route exact
                path="/terms-and-conditions"
                component={Terms} />
              <Route exact
                path="/collaborate"
                component={Collaborate} />
            </Switch>
          </Content>
          <GlobalStyle />
        </OuterContainer>
      </BrowserRouter>
    </ThemeProvider>
  </div>
  );
}

export default connect(
  ({ sidebar }) => ({ sidebarCollapsed: sidebar.collapsed, sidebarHidden: sidebar.hidden })
)(App);
